import auth from "./AuthAPI.js";
import Http from "./Http.js";
import * as APPCONFIG from "../config/app-config.js";
import api from "./BaseAPI.js";


class ServiceProvider {

  // POST - sends providerId + deduped specializationIds array in the body.
  // Backend overwrites providerId server-side from the auth token, but we still
  // send it for consistency/logging.
// Existing question config
getQuestion(providerId, specializationIds, feedbackId) {
  return auth({
    method: "post",
    headers: Http.AUTH_HEADERS(),
    url: `${APPCONFIG.API_URL}api/getQuestion`,
    data: { specializationIds, feedbackId }, // feedbackId optional — null on first-time setup
  });
}

saveQuestionSelection(feedbackId, selection) {
  return auth({
    method: "post",
    headers: Http.AUTH_HEADERS(),
    url: `${APPCONFIG.API_URL}api/saveQuestionSelection`,
    data: { feedbackId, selection }, // selection: [{ questionId }, { questionId, type }]
  });
}

// New: link management
createFeedbackLink() {
  return auth({
    method: "post",
    headers: Http.AUTH_HEADERS(),
    url: `${APPCONFIG.API_URL}api/feedback/create`,
  });
}

// Combined create+configure — used by the "New Form" flow. Nothing is
// persisted on the backend until this call succeeds: the link and its
// question selection are created together in one transaction, so picking
// questions and backing out never leaves an empty form behind.
createFeedbackLinkWithSelection(selection) {
  return auth({
    method: "post",
    headers: Http.AUTH_HEADERS(),
    url: `${APPCONFIG.API_URL}api/feedback/create-with-selection`,
    data: { selection },
  });
}

activateFeedbackLink(feedbackId) {
  return auth({
    method: "post",
    headers: Http.AUTH_HEADERS(),
    url: `${APPCONFIG.API_URL}api/feedback/${feedbackId}/activate`,
  });
}

deactivateFeedbackLink(feedbackId) {
  return auth({
    method: "post",
    headers: Http.AUTH_HEADERS(),
    url: `${APPCONFIG.API_URL}api/feedback/${feedbackId}/deactivate`,
  });
}


listFeedbackLinks() {
  return auth({
    method: "get",
    headers: Http.AUTH_HEADERS(),
    url: `${APPCONFIG.API_URL}api/feedback/list`,
  });
}

  getForm(token) {
    return api({
      method: "get",
      url: `${APPCONFIG.API_URL}auth/${token}`,
    });
  }

  submit(token, payload) {
    return api({
      method: "post",
      url: `${APPCONFIG.API_URL}auth/${token}/submit`,
      data: payload,
    });
  }

  // api/ServiceProvider.js
listSubmissions(feedbackId) {
  return auth({
    method: "get",
    headers: Http.AUTH_HEADERS(),
    url: `${APPCONFIG.API_URL}api/feedback/${feedbackId}/submissions`,
  });
}


listContacts(page = 0, size = 20) {
  return auth({
    method: "post",
    headers: Http.AUTH_HEADERS(),
    url: `${APPCONFIG.API_URL}api/provider/contacts/list?page=${page}&size=${size}`,
  });
}

getContact(contactId) {
  return auth({
    method: "post",
    headers: Http.AUTH_HEADERS(),
    url: `${APPCONFIG.API_URL}api/provider/contacts/get`,
    data: { contactId },
  });
}

createContact(payload) {
  return auth({
    method: "post",
    headers: Http.AUTH_HEADERS(),
    url: `${APPCONFIG.API_URL}api/provider/contacts/create`,
    data: payload,
  });
}

updateContact(contactId, payload) {
  return auth({
    method: "post",
    headers: Http.AUTH_HEADERS(),
    url: `${APPCONFIG.API_URL}api/provider/contacts/update`,
    data: { contactId, ...payload },
  });
}

updateContactMobileNumber(contactId, mobileNumber) {
  return auth({
    method: "post",
    headers: Http.AUTH_HEADERS(),
    url: `${APPCONFIG.API_URL}api/provider/contacts/mobile-number`,
    data: { contactId, mobileNumber },
  });
}

deleteContact(contactId) {
  return auth({
    method: "post",
    headers: Http.AUTH_HEADERS(),
    url: `${APPCONFIG.API_URL}api/provider/contacts/delete`,
    data: { contactId },
  });
}


saveClientEmail(payload) {
  return auth({
    method: "post",
    headers: Http.AUTH_HEADERS(),
    url: `${APPCONFIG.API_URL}api/provider/client-emails/save`,
    data: payload,
  });
}

listClientEmails(activeOnly = true, page = 0, size = 20) {
  return auth({
    method: "post",
    headers: Http.AUTH_HEADERS(),
    url: `${APPCONFIG.API_URL}api/provider/client-emails/list?activeOnly=${activeOnly}&page=${page}&size=${size}`,
  });
}

// Full email history + count for one client — powers the count/history
// shown on the Client Detail page.
getClientEmailsForContact(contactId) {
  return auth({
    method: "post",
    headers: Http.AUTH_HEADERS(),
    url: `${APPCONFIG.API_URL}api/provider/client-emails/by-contact?contactId=${contactId}`,
  });
}

// Batched { contactId: count } map for every contact of this provider —
// one call, used to render the count column in the Clients table without
// an N+1 request per row.
getClientEmailCounts() {
  return auth({
    method: "get",
    headers: Http.AUTH_HEADERS(),
    url: `${APPCONFIG.API_URL}api/provider/client-emails/counts`,
  });
}

// Sends one message to every active client. Backend queues one PENDING
// email per contact — same delivery pipeline as an individual send.
broadcastClientEmail(subject, message) {
  return auth({
    method: "post",
    headers: Http.AUTH_HEADERS(),
    url: `${APPCONFIG.API_URL}api/provider/client-emails/broadcast`,
    data: { subject, message },
  });
}


}

export default new ServiceProvider();